import React, {CSSProperties} from 'react'
import styled from 'styled-components'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledLocationItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${convertUnit(8)};
  align-items: center;
  margin-bottom: ${convertUnit(16)};
  cursor: pointer;
`

const StyledLocationIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  padding: ${convertUnit(4)};
  aspect-ratio: 1;
  background-color: ${({theme}) => theme.gray_1};
`

export function GiftshopFilterRegencyListItem({
  name,
  style,
  onSelect,
}: {
  name: string
  style?: CSSProperties
  onSelect: () => void
}) {
  return (
    <StyledLocationItemContainer style={style} onClick={onSelect}>
      <StyledLocationIconContainer>
        <Icon type="location" color="gray_5" />
      </StyledLocationIconContainer>
      <Paragraph fontWeight="bold">{name}</Paragraph>
    </StyledLocationItemContainer>
  )
}
